// Offline Storage Utility — DISABLED
//
// localStorage translation caching is intentionally turned off. When admin
// updates a translation in the DB, users with cached entries kept seeing
// the old wrong version until they manually cleared their browser data.
// All functions below are no-ops; the file is kept so existing imports
// in App.js continue to compile without breaking changes.
//
// On module load, any leftover localStorage entries from previous app
// versions are wiped — so users who upgrade automatically get a fresh slate.

const STORAGE_PREFIX = 'darija_offline_';
const TRANSLATIONS_KEY = `${STORAGE_PREFIX}translations`;
const LAST_SYNC_KEY = `${STORAGE_PREFIX}last_sync`;

// One-time cleanup on app load — removes any pre-existing translation cache
try {
  localStorage.removeItem(TRANSLATIONS_KEY);
  localStorage.removeItem(LAST_SYNC_KEY);
} catch (_e) { /* localStorage unavailable, ignore */ }

export const saveTranslationOffline = () => false;
export const getTranslationOffline = () => null;
export const getCachedTranslations = () => ({});
export const clearOfflineData = () => true;
export const getCacheStats = () => ({ totalItems: 0, storageUsed: 0 });
export const updateLastSync = () => undefined;
export const getLastSync = () => null;
